import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: false,

    //manual data
    selectedSubject: null,
    selectedTeacher: null,
    subjects: [],
    teachers: [],
    courseOutlines: [],

    //vdoSetEdit page
    vdoSetEdit: {
      courseOutline: null,
    },
    //vdoSet info page
    vdoSetInfo: {
      selectedVdoSet: null,
      form: {
        id: '',
        degreeId: null,
        courseOutlineId: null,
        subjectGroupId: null,
        subjectId: null,
        teacherId: null,
        vdoSetInput: {
          subjectCode: '',
          teacherCode: '',
          code: '',
          description: '',
          totalVdoLength: 0,
        },

      }

    },
    //vdoSetUnit Edit page
    vdoSetUnitEdit: {
      selectedVdoSetUnit: null,
      form: {
        name: '',
        vdoSetUnitInput: {
          remark: '',
          status: false,
        },
      }
    },
    //vdoSetTopic Edit page
    vdoSetTopicEdit: {
      selectedVdoSetTopic: null,
      form: {
        vdoSetTopicInput: {
          no: '',
          nameLocal: '',
          nameEng: '',
          vdoLength: '',
          vdoStreamPath: '',
          isEnabled: false,
          remark: '',
          descriptionLocal: '',
          descriptionEng: '',
          thumbnail: null,
        },
      }
    },
    isUploading: false,


    //preview page
    showPreviewVideoPopUp: false,

  })
};

export const template = {
  table: {
    header: [
      {title: 'vdo-set.no', id: 'no'},
      {title: 'vdo-set.subject-code', id: 'SubjectCode'},
      {title: 'vdo-set.subject-name', id: 'subjectName'},
      {title: 'vdo-set.credit', id: 'credit'},
      {title: 'vdo-set.teacher', id: 'teacher'},
      {title: 'vdo-set.course-outline-unit-qty', id: 'courseOutlineUnitQty'},
      {title: 'vdo-set.vdo-set-total-qty', id: 'vdoSetQty'},
      {title: '', id: ''},
    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

export const loadData = async (func) => {

  //must select some filter to load data to prevent load too many date
  if ((state.local.selectedSubject && state.local.selectedSubject.id)
    || (state.local.selectedTeacher && state.local.selectedTeacher.id)) {

    let payload = {
      courseOutlineFilterInput: {
        subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
        teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
      }
    };

    if (func.getCourseOutlinesByFilterForTable) {
      state.local.courseOutlines = await func.getCourseOutlinesByFilterForTable(payload);
    }
  } else {
    state.local.courseOutlines = [];
  }

};

export const setEmptyVdoSetTopicForm = () => {
  state.local.vdoSetTopicEdit.selectedVdoSetTopic = null

  let no = 1;
  if (state.local.vdoSetUnitEdit.selectedVdoSetUnit
    && state.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics
    && state.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.length > 0) {
    no = state.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics[
    state.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.length - 1].no + 1;
  }
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.no = no;
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.nameLocal = '';
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.nameEng = '';
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.vdoLength = '';
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.isEnabled = false
  state.local.vdoSetTopicEdit.form.vdoSetTopicInput.remark = '';
}

export const getFileName = (prefix) => {
  return prefix
    + '_' + state.local.vdoSetEdit.courseOutline.subject.code
    + '_' + state.local.vdoSetEdit.courseOutline.teacher.code
    + '_' + state.local.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq
    + '_' + state.local.vdoSetTopicEdit.selectedVdoSetTopic.no
    + '_' + state.local.vdoSetTopicEdit.selectedVdoSetTopic.id
    + '.mp4';
}

export const getPaths = () => {
  return  state.local.vdoSetEdit.courseOutline.subject.code
    + ',' + state.local.vdoSetInfo.selectedVdoSet.code
    + ',' + state.local.vdoSetEdit.courseOutline.teacher.code
    + ',' + state.local.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq
}
//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
